import React, {useEffect, useState} from 'react';
import {Modal, Row, Col} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';
import {GreenButton, WhiteButton} from '@styled';
import {Input, Form, MainLoader} from '@components';
import {useDispatch, useSelector} from 'react-redux';
import {sagaActions} from './redux/saga';
import {resetFormSubmitSuccess, resetFormError} from './redux/index';

const AddEditCategory = ({show, editRow, toggleModal}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState('add');
  const isLoading = useSelector((state) => state.calcEngine.formLoading);
  const formError = useSelector((state) => state.calcEngine.formError);
  const formSubmitSuccess = useSelector(
    (state) => state.calcEngine.formSubmitSuccess
  );

  useEffect(() => {
    if (formSubmitSuccess) {
      dispatch(resetFormSubmitSuccess(false));
      toggleModal(false);
    }
  }, [formSubmitSuccess]);

  useEffect(() => {
    setEditMode(editRow ? 'update' : 'add');
  }, [editRow]);

  useEffect(() => {
    dispatch(resetFormError(''));
  }, [show]);

  const handleSubmit = (values) => {
    dispatch({
      type:
        editMode === 'update'
          ? sagaActions.UPDATE_CATEGORY
          : sagaActions.CREATE_CATEGORY,
      payload: {categoryId: editRow ? editRow.id : 0, values},
    });
  };

  return (
    <Modal
      show={show}
      onHide={() => toggleModal(false)}
      centered
      scrollable
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <h6>{t(`owner.calcEngine.categories.${editMode}`)}</h6>
      </Modal.Header>
      <Modal.Body>
        {isLoading && (
          <MainLoader
            minHeight="100vh"
            spinnerColor="#479541"
            background="rgba(0,0,0,0.2)"
          />
        )}
        <Form
          initialValues={{
            name: editRow ? editRow.name : '',
          }}
          validationSchema={Yup.object({
            name: Yup.string().required(
              t('owner.calcEngine.categories.required.name')
            ),
          })}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
          enableReinitialize={editMode === 'update' ? true : false}
        >
          {formError && <div className="alert alert-danger">{formError}</div>}
          <Row>
            <Col>
              <Input
                type="text"
                name="name"
                id="name"
                label={t('owner.calcEngine.categories.name')}
                placeholder=""
                required
              />
            </Col>
          </Row>
          <div
            style={{
              visibility: 'hidden',
              width: 0,
              lineHeight: 0,
              padding: 0,
              margin: 0,
              fontSize: 0,
            }}
          >
            <GreenButton id="mCatSubmitBtn" type="submit">
              {t(`owner.calcEngine.categories.${editMode}BtnLabel`)}
            </GreenButton>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <GreenButton
          type="button"
          className="mr-1"
          onClick={() => {
            document.getElementById('mCatSubmitBtn').click();
          }}
        >
          {t(`owner.calcEngine.categories.${editMode}BtnLabel`)}
        </GreenButton>
        <WhiteButton
          type="button"
          className="ml-1"
          onClick={() => toggleModal(false)}
        >
          {t('owner.calcEngine.categories.cancelBtnLabel')}
        </WhiteButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEditCategory;
